export default __webpack_public_path__ + "static/media/magentoLogo@2x.d6965783.png";